// Согласие с правилами чата (ВР-69 Ч3; ADR-0028 §7; Р-101): отдельная строка при первом входе в чат кооператива и
// пункт в SCR-LEGAL. Версия — последний сегмент адреса документа из clientConfig.values.legal.urls.chat_rules
// (`…/legal/chat_rules/1`). Принятая версия хранится на устройстве; сервер записывает согласие (POST /me/consents).
import { clientConfig } from './game.js';
import { storage } from './storage.js';

const KEY = 'chatRulesAccepted';

export function legalUrls(): Record<string, string> {
  return ((clientConfig.value['legal'] ?? {}) as { urls?: Record<string, string> }).urls ?? {};
}

/** Версия документа из адреса `/legal/<docId>/<версия>`; null — адреса нет. */
export function docVersion(url: string | undefined | null): string | null {
  const m = url ? /\/([^/?#]+)\/?(?:[?#].*)?$/.exec(url) : null;
  return m ? decodeURIComponent(m[1]!) : null;
}

/** Текущая версия правил чата; null — документа в конфиге нет, согласие не спрашиваем. */
export function chatRulesVersion(): string | null { return docVersion(legalUrls()['chat_rules']); }

export function chatRulesAccepted(): boolean {
  const v = chatRulesVersion();
  return !v || storage.get(KEY) === v;
}
export function markChatRulesAccepted(version: string): void { storage.set(KEY, version); }
